export default __webpack_public_path__ + "static/media/093-diagonal-arrow.e92db1d7.png";